export default __webpack_public_path__ + "static/media/basic-pin-small-8.dd94c859.png";